import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconMailReadProps } from './IconMailRead.types'
import * as Styled from './styles/IconMailRead.style'

import { nonThemeableRules } from '../../ruleSet'

const IconMailRead: FC<IconMailReadProps> = ({
  size = nonThemeableRules.defaultSize as number as IconMailReadProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconMailReadProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path d='m159 85.7-52.9 54.5c-5.7 5.9-15.1 6.2-21.1.5l-.5-.5L33 85.7' vectorEffect='non-scaling-stroke' />
          <path d='m30 88.2 56-54.5c5.7-5.9 15.1-6.2 21.1-.5l.5.5L162 88.2' vectorEffect='non-scaling-stroke' />
          <path
            d='M33 85.7c-4.3 1.5-5 7.6-5 10.5v60c0 8.8 7.2 16 16 16h104c8.8 0 16-7.2 16-16v-60c0-2.9-.8-9-5-10.5'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconMailRead
